import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../styles/home.module.css';

const HeroSection = ({
  title,
  subtitle,
  description,
  ctaText,
  ctaLink,
  secondaryCtaText,
  secondaryCtaLink,
}) => {
  return (
    <section className={styles.hero}>
      <h1 className={styles.welcome}>{title}</h1>
      <p className={styles.subTitle}>
        <strong>{subtitle}</strong>
      </p>
      <p className={styles.description}>
        {description}
      </p>
      <div className={styles.heroActions}>
        <Link to={ctaLink}>
          <button className={styles.primaryButton} type="button">{ctaText}</button>
        </Link>
        {secondaryCtaText && secondaryCtaLink && (
          <a href={secondaryCtaLink} target="_blank" rel="noopener noreferrer">
            <button className={styles.primaryButton} type="button">{secondaryCtaText}</button>
          </a>
        )}
      </div>
    </section>
  );
};

export default HeroSection;